import React from "react";
import UpdatePageLoader from "../../Components/Loaders/UpdatePageLoader";
import { useVehicleForm } from "./useVehicleForm";
import VehicleFormView from "./VehicleFormView";

function VehicleFormPage({ mode }) {
  const form = useVehicleForm(mode);

  if (form.isLoading) {
    return <UpdatePageLoader mode={mode} />;
  }

  return <VehicleFormView mode={mode} form={form} />;
}

export default VehicleFormPage;
